/**
 * Montant d'une ligne de commande, regle unique du back-office.
 *
 * Les commandes reelles (app client, caisse) portent `unit_price` (options
 * comprises) et `total_price` = unit_price x quantite, jamais `price` : `price`
 * n'existe que dans le panier avant validation. Lire `price` donnait 0 EUR par
 * produit sur toute commande reelle (Top produits du tableau de bord).
 * Meme regle que integrations/familys-mcp/src/analytics.ts (lineRevenue) :
 * total_price, sinon unit_price x quantite, sinon l'ancien champ price.
 */

const toNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const present = (value) => value !== undefined && value !== null && value !== '';

export const lineQuantity = (item) => toNumber(item?.quantity) || 1;

export const lineRevenue = (item) => {
  if (!item) return 0;
  if (present(item.total_price)) return toNumber(item.total_price);
  if (present(item.unit_price)) return toNumber(item.unit_price) * lineQuantity(item);
  return toNumber(item.price) * lineQuantity(item);
};
